import { useAuthUser } from '@/src/hooks/auth';
import { useCurrentDeviceStore } from '@/src/modules/pricing/hooks/useCurrentDeviceStore';
import { useIsRevenueCatAvailable } from '@/src/modules/pricing/hooks/useIsRevenueCatAvailable';
import useQueryRevenueCatCustomerInfo from '@/src/modules/pricing/queries/useQueryRevenueCatCustomerInfo';
import { getSubscriptionAccess } from '@/src/modules/pricing/utils/getSubscriptionAccess';
import type { SubscriptionAccess } from '@fabric-app/types/pricing/pricing.types';
import { useMemo } from 'react';

export const useSubscriptionAccess = () => {
  const user = useAuthUser();
  const { data: customerInfo, isLoading } = useQueryRevenueCatCustomerInfo({
    refetchOnMount: 'always',
  });
  const isRevenueCatAvailable = useIsRevenueCatAvailable();
  const currentDeviceStore = useCurrentDeviceStore();

  return useMemo<SubscriptionAccess>(() => {
    if (!user) {
      return {
        canAlterSubscription: {
          allowed: false,
          reason: 'missing_user',
        },
        canManageSubscription: {
          allowed: false,
          reason: 'missing_user',
        },
        originalStore: currentDeviceStore,
      };
    }

    if (isLoading) {
      return {
        canAlterSubscription: {
          allowed: true,
        },
        canManageSubscription: {
          allowed: true,
        },
        originalStore: currentDeviceStore,
        userEntitlement: undefined,
      };
    }

    return getSubscriptionAccess({ user, customerInfo, isRevenueCatAvailable, currentDeviceStore });
  }, [user, isLoading, customerInfo, isRevenueCatAvailable, currentDeviceStore]);
};
